import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-tax-category-form',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './tax-category-form.component.html',
  styleUrl: './tax-category-form.component.scss'
})
export class TaxCategoryFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  Detail = {
    SelectType: 'insert',
    ESS_TaxCategoryMasterID: 0,
    Name: null,
    FromAge: null as any,
    ToAge: null as any,
    Category: null,
  }

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private incometax: IncometaxService
  ) {
    this.common.getPageRights();
    this.Detail.ESS_TaxCategoryMasterID = this.ID;
  }

  ngOnInit(): void {
    if (this.Detail.ESS_TaxCategoryMasterID == undefined) {
      this.Detail.ESS_TaxCategoryMasterID = 0;
    }
    if (this.ID > 0) {
      this.TaxCategoryMasterSelectLoad();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if(this.Detail.ToAge > this.Detail.FromAge){
        this.TaxCategoryMasterInsertUpdate();
      }else{
        this.toast.show({message:"To age greater than from age",type:toastTypeEnum.danger});
      }
    }
    else {
      form.submitted = true;
    }
  }

  TaxCategoryMasterSelectLoad() {
    this.Detail.ESS_TaxCategoryMasterID = this.ID;
    this.isDisabled = true;
    this.incometax.TaxCategoryMasterSelectLoad({ SelectType: 'S', ESS_TaxCategoryMasterID: this.Detail.ESS_TaxCategoryMasterID }).subscribe({
      next: (response) => {
        if (response.Table || response.Table.length > 0) {
          this.Detail = response.Table[0];
          this.Detail.SelectType = 'update';
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async TaxCategoryMasterInsertUpdate() {
    if (this.common.PageRight.IsEdit) {
      this.incometax.TaxCategoryMasterInsertUpdate(this.Detail).subscribe({
        next: async (response) => {
          if (response.Error_Code == '672' || response.Error_Code == '673') {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              this.close(true);
            });
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  close(flag = false) {
    this.activeModal.close(flag);
  }
}

